// extracted by mini-css-extract-plugin
export default {"currentImage":"imageUploader__currentImage--cXTuu","btnContainer":"imageUploader__btnContainer--Rnntp","btn":"imageUploader__btn--wG_R4","label":"imageUploader__label--MiETJ"};